
import { Component, Vue } from "nuxt-property-decorator";

@Component({})
export default class ArtcileAtom extends Vue {}
